import React, { useState, useEffect, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';
 
const AcceptReject = ({
    actionObj,
    onClick,
    reject = true,
    id,
    isView = false,
                          setLeadId = () => {},
                          setSiteId = () => {}
}) => {
    const [data, setData] = useState();
    const acceptClicked = (accept) => {
        let actionObj = data;
        onClick({ action: accept, actionObj: actionObj })
    }
    const rejectClicked = (reject) => {
        onClick({ action: reject, actionObj: actionObj })
    }
    useEffect(() => {
        setData(actionObj)
        setLeadId(actionObj?.id)
        setSiteId(actionObj?.comm_id)
    }, [actionObj])


    // useEffect(() => {
    //     setLeadId(data?.id)
    //     setSiteId(data?.comm_id)
    // }, [data])

    return (
        <Fragment>
            <span className="accept-reject">
                {isView?
                    <Link to="#" data-toggle="modal" data-target="#accept" className="accept" onClick={() => acceptClicked(true)}></Link>
                    :
                    <Link to="#" data-toggle="modal" data-target="#accept" className="accept" onClick={() => acceptClicked("accept")}></Link>
                }

                {reject && <Link to="#" data-toggle="modal" data-target="#reject" className="reject" onClick={() => rejectClicked("reject")}></Link>}
            </span>
        </Fragment>
    )
}

AcceptReject.propTypes = {
    actionObj: PropTypes.any,
    onClick: PropTypes.any,  
}

export default AcceptReject
